module.exports = __webpack_public_path__ + "img/2ab2420.jpg";